import firebase from "firebase/app";
import "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_API_ID,
  measurementId: process.env.REACT_APP_MESSUREMENT_ID,
  // apiKey: "AIzaSyA0agOL2uFGeAzw5g2MeXeuJmdoPzrLbV0",
  // authDomain: "atrable-project.firebaseapp.com",
  // projectId: "atrable-project",
  // storageBucket: "atrable-project.appspot.com",
  // messagingSenderId: "709817227745",
  // appId: "1:709817227745:web:6bc2f03910625b8d079aa0",
  // measurementId: "G-5CFYZGPB8Q",
  //github에 업로드되지 않도록 .env파일을 별도로 만듦
  //.env 파일 만들기 전에 이미 커밋 했으므로 나는 그냥 소스코드를 비공개로 냅두기
};

firebase.initializeApp(firebaseConfig);

export const myFirebase = firebase;

export const authService = firebase.auth();
